import { useTranslation as _useTranslation } from '@crehana/i18n';

import { COMPONENT_KEY } from '../constants';
import locales from '../i18n';
import type { TKeys } from '../i18n/types';

export const useTranslation = () => {
  const { addResourceBundle, ...translationContextValue } =
    _useTranslation<TKeys>(COMPONENT_KEY);

  addResourceBundle(locales);
  return translationContextValue;
};
